
import {  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import CustomCancelButton from "./CustomCancelButton";
import Button from '@mui/material/Button';

export default function Dialogbox({ dialogtitle, dialogtext, openDialog, handleCloseDialog, handleConfirmDialog, themechange , confirmText, cancelText}) {
    return(
        <Dialog
            open={openDialog}
            onClose={handleCloseDialog}
            BackdropProps={{
                sx:{
                    backgroundColor: (themechange == 'light')?'rgba(0,0,0,0.3)':'rgba(255,255,255,0.3)'
                }
            }}
            sx={{ "& .MuiDialog-paper": { borderTopLeftRadius:"40px", borderTopRightRadius:"40px",  backgroundColor:(themechange == 'light')?"#FFFFFF":"#19191B"} }}
        >
            <DialogTitle  sx={{color:"#FFFFFF", backgroundColor:"#005C8E",margin:"5px", borderRadius:"100px", }}>{dialogtitle}</DialogTitle>
            <DialogContent >
                <DialogContentText sx={{color:(themechange == 'light')?"#19191B":"#FFFFFF"}}>
                   {dialogtext}
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{justifyContent:'center'}}> 
                <Button onClick={handleConfirmDialog} sx={{ outline:'none !important',boxShadow:'none', height:'35px', width:"88px", fontSize: '16px',textTransform:'capitalize', marginRight:"5px",backgroundColor:"#005C8E", borderRadius:"20px"}} variant="contained" autoFocus>
                    {confirmText}
                </Button>
                <CustomCancelButton onClick={handleCloseDialog} buttonText={cancelText}></CustomCancelButton>
            </DialogActions>
        </Dialog>
    );

}